import posthog from 'posthog-js';

let _initialized = false;

export const initAnalytics = () => {
  const key = import.meta.env.VITE_POSTHOG_KEY;
  if (!key) return;

  posthog.init(key, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    // Manual page view tracking via RouteChangeTracker
    capture_pageview: false,
    // Use localStorage instead of cookies for GDPR compliance
    persistence: 'localStorage',
  });
  _initialized = true;
};

export const identifyUser = (userId: string, properties?: Record<string, unknown>) => {
  if (!_initialized) return;
  posthog.identify(userId, properties);
};

export const resetAnalyticsUser = () => {
  if (!_initialized) return;
  posthog.reset();
};

export const trackPageView = () => {
  if (!_initialized) return;
  posthog.capture('$pageview', { $current_url: window.location.href });
};

export const trackEvent = (event: string, properties?: Record<string, unknown>) => {
  if (!_initialized) return;
  posthog.capture(event, properties);
};
